import { afterEvent, defineGameCard, } from '../authoring/index.js';
export const VoltaicAccumulatorCard = defineGameCard({
    id: 'voltaic_accumulator',
    gameplay: {
        type: 'UNIT', cost: 3,
        baseStats: { attack: 2, health: 5 }, keywords: ['RUSH'],
    },
    presentation: {
        name: 'Вольтов накопитель',
        description: 'Натиск. Раз за раунд, когда другая союзная карта полностью охлаждается, Вольтов накопитель получает +2 к атаке и +1 к здоровью.',
        glyph: {
            colors: ['#EED151', '#10213A', '#C1B889', '#585874', '#414156'],
            rows: [
                '.....1........1.....',
                '.....11......11.....',
                '......1......1......',
                '.....213....212.....',
                '1...221322222122..1.',
                '.11.333333333334.1..',
                '..1155555544444411..',
                '....2222222222221...',
                '....244414414422..1.',
                '....254411411422.1..',
                '...12554414414221...',
                '..1.25555444442211..',
                '..1.222225542222..1.',
                '.1..2....222...2....',
                '1...................',
                '....................',
                '....................',
                '....................',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [afterEvent({
            event: 'HeatChanged',
            frequency: 'first_per_round',
            abilityId: 'full_cooling_charge',
            when: (ctx, event) => {
                const self = ctx.self;
                if (self === undefined || event.instanceId === self.id
                    || event.reason !== 'cooled' || event.previous <= 0 || event.current !== 0)
                    return false;
                return ctx.q.instance(event.instanceId)?.controllerId === self.controllerId;
            },
            run: (ctx) => {
                if (ctx.self === undefined)
                    return;
                ctx.ops.modifyStat(ctx.self.id, 'attack', 2);
                ctx.ops.modifyStat(ctx.self.id, 'maxHealth', 1);
                ctx.ops.modifyStat(ctx.self.id, 'health', 1);
            },
        })],
    ui: { mechanics: ['rush', 'heat', 'cool'] },
});
//# sourceMappingURL=voltaic_accumulator.js.map